import { useState } from "react";
import { Menu, X } from "lucide-react";

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { label: "HOME", href: "/#hero" },
    { label: "ABOUT", href: "/#about" },
    { label: "SERVICES", href: "/#services" },
    { label: "PROJECTS", href: "/#projects" },
    { label: "CONTACT US", href: "/#contact" },
  ];

  return (
    <header className="bg-[#E9E3D5] py-3 md:py-4 shadow-md font-inter w-full z-50 relative">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-4 md:px-10">

        {/* === Logo === */}
        <div className="flex justify-start">
          <a href="#hero">
            <img
              src="/logo.png"
              alt="AMK Logo"
              className="w-20 md:w-28 lg:w-32 h-auto object-contain cursor-pointer"
            />
          </a>
        </div>

        {/* === Tombol Hamburger (Mobile) === */}
        <div className="md:hidden">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="text-[#2D435B] hover:text-[#1A2A3B] transition"
          >
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* === Menu Navigasi (Desktop) === */}
        <nav className="hidden md:flex justify-center flex-1 ml-6 md:ml-12">
          <ul className="flex flex-wrap justify-center items-center space-x-5 md:space-x-10 lg:space-x-14">
            {navItems.map((item) => (
              <li key={item.label}>
                <a
                  href={item.href}
                  className="font-semibold text-[#2D435B] text-[12px] md:text-[14px] lg:text-[14px] px-3 py-2 rounded-full transition-all duration-300 hover:bg-[#2D435B] hover:text-white hover:shadow-md"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      {/* === Menu Navigasi Mobile === */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-500 ease-in-out bg-[#E9E3D5] shadow-md ${
          isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <ul className="flex flex-col items-center space-y-4 py-5">
          {navItems.map((item) => (
            <li key={item.label}>
              <a
                href={item.href}
                className="font-semibold text-[#2D435B] text-[13px] px-4 py-2 rounded-full transition-all duration-300 hover:bg-[#2D435B] hover:text-white hover:shadow-md"
                onClick={() => setIsOpen(false)} // Tutup menu saat diklik
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </header>
  );
}
